module.exports = __webpack_public_path__ + "img/icon_stop.76cc703b.svg";